import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import HotComicsGrid from './components/HotComicsGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '虫虫漫画网',
  url: 'https://www.chongchongmanhua.com',
  description:
    '虫虫漫画网主打下拉式完整版免费阅读，无删减韩国漫画资源充足，下拉观看流畅不卡顿，免费为您呈现各类精彩韩国漫画的完整版剧情与画面。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.chongchongmanhua.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="下拉式完整版免费阅读 无删减漫画免费阅读「下拉观看」-虫虫漫画网"
        description="虫虫漫画网主打下拉式完整版免费阅读，无删减韩国漫画资源充足，下拉观看流畅不卡顿，免费为您呈现各类精彩韩国漫画的完整版剧情与画面。下拉式漫画，无删减漫画，免费阅读，韩国漫画，下拉观看，虫虫漫画网"
        keywords="下拉式漫画,无删减漫画,免费阅读,韩国漫画,下拉观看,虫虫漫画网"
        canonicalUrl="https://www.chongchongmanhua.com"
        schema={homeSchema}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeatureGrid />
        <HotComicsGrid />
        <TestimonialSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}